module.exports = __webpack_public_path__ + "static/woman_set_7senior.db0b4a4d.svg";